module.exports = __webpack_public_path__ + "static/media/empty-array.9326ab13.png";